import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { client } from '@chegg/pricing-sdk';
import { CheggEnv, CookieName, getCookie, isWindowDefined } from '@chegg/utils';
export var getCheckoutAuthParams = function getCheckoutAuthParams(sdkKey, cheggEnv) {
  return {
    apiKey: sdkKey,
    cheggBaseUrl: cheggEnv === CheggEnv.PROD ? 'https://www.chegg.com' : 'https://trunk.live.test.cheggnet.com',
    cheggGraphQLUrl: cheggEnv === CheggEnv.PROD ? 'https://gateway.chegg.com' : 'https://gateway.test.cheggnet.com',
    idToken: isWindowDefined ? getCookie(CookieName.ID_TOKEN) : undefined,
    useBFF: true
  };
};

/**
 * used to authorize user
 * @returns
 */
export var authorize = function authorize(authorizePayload) {
  return client.authorize(_objectSpread({}, authorizePayload));
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/dist/esm/utils/checkoutAuthorization.js
// module id = 1542
// module chunks = 11